import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/success/logo.png'
import _imports_1 from '@/assets/success/class.png'


const _withScopeId = n => (_pushScopeId("data-v-4cbcd3d7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "questionnaire-success hea-column" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "logo"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "class"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "视频问卷已完成", -1))

import { onMounted, ref, computed } from 'vue';
    import { Toast } from 'vant';
    import tabbar from "src/components/common/tabbar";
    import JSEncryptUtils from 'utils/encrypt-utils';
    import dayjs from 'dayjs';
    import { QuestionnaireService, GaodeService } from 'src/services';
    import {useToken } from 'src/store';
    import { useRouter, useRoute } from 'vue-router';
    import UpageList from 'src/components/common/page-list';
    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const { setAccessToken, setRefreshToken } = useToken();
    
    const router = useRouter();
    const route = useRoute();

    /**
     * 体检任务id 
     * @private
     * @returns boolean
     */
    const id = computed({
        get() {
            return route.query && route.query.id;
        },
        set(value)
        {
        }
    })

    const goPage = (name: string) => 
    {
        setTimeout(() => {
            router.push({name: name})
        }, 200)
    }

    // 前往体检预约
    const goPhysical = () => 
    {
        router.push({name: "detail", query: {id: id.value + ""}})
    }
    
    

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("div", {
      class: "goAppointment hea-justifyC",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (goPhysical()))
    }, "前往体检预约"),
    _createElementVNode("div", {
      class: "goHome hea-justifyC",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (goPage('home')))
    }, "返回首页")
  ]))
}
}

})